import { useParams } from 'react-router-dom';
import { capitalize } from 'lodash';
import { ClusterStatusEnum } from '~/api/types';
import { useGetClustersQuery, useGetProjectQuery } from '~/api/v2/hooks';
import { TableFilterType } from '~/components/Table/components/filters/types';
import { ClusterFiltersType } from './types';

interface FiltersClusterConfig {
  emrId: number;
}

const useFiltersClusterConfig = ({ emrId }: FiltersClusterConfig) => {
  const projectId = +useParams().projectid!;
  // Args must match the table query's empty state so RTK Query reuses one cache entry instead of firing a duplicate request
  const { data: clustersData } = useGetClustersQuery({
    projectId,
    emrId,
    sort_elapsed: false,
    search: '',
    statusList: [],
    createdOn: [],
    createdBy: [],
    clusterId: [],
  });
  const { data: projectData } = useGetProjectQuery({ projectId });

  const filterOptions = [
    {
      id: ClusterFiltersType.ID,
      name: 'Id',
      type: TableFilterType.AUTOCOMPLETE,
      options: clustersData?.data.map((cluster) => ({
        id: cluster.aws_cluster_id,
        label: cluster.aws_cluster_id,
      })),
    },
    {
      id: ClusterFiltersType.STATUS,
      name: 'Status',
      type: TableFilterType.CHECKBOX,
      options: Object.values(ClusterStatusEnum)
        .map((cluster) => ({
          id: cluster,
          label: capitalize(cluster.replaceAll('_', ' ').toLowerCase()),
        }))
        .filter((option) => clustersData?.data.some((cluster) => cluster.status === option.id)),
    },
    {
      id: ClusterFiltersType.CREATED_ON,
      name: 'Created on',
      type: TableFilterType.DATE,
    },
    {
      id: ClusterFiltersType.CREATED_BY,
      name: 'Created by',
      type: TableFilterType.MULTIPLE_AUTOCOMPLETE,
      options: projectData?.members
        .map((config) => ({
          id: config.id,
          label: `${config.first_name} ${config.last_name}`,
        }))
        .filter((option) => clustersData?.data.some((cluster) => cluster.creator.id === option.id)),
    },
  ];

  return filterOptions;
};

export default useFiltersClusterConfig;
